const baseUrl = '/hrss-platform-marketing/v1'

export default (API) => ({
    checkBindStatus() {
        return API({
            url: `${baseUrl}/client/physicalcard/getCardInfo`,
            method: 'post',
        })
    },
    // 激活
    bind(data) {
        return API({
            url: `${baseUrl}/client/physicalcard/activate`,
            method: 'post',
            data,
        })
    },
    // 学员端-权益列表查询（各会员）
    equityList(data) {
        return API({
            url: '/hrss-platform-marketing/v1/physicalCardCodeUserEquity/equityList',
            method: 'get',
            data,
        })
    },
    // 学员端-兑换充值
    equitySave(data) {
        return API({
            url: '/hrss-platform-marketing/v1/physicalCardCodeUserEquity/save',
            method: 'post',
            data,
        })
    },
    getCourseList(data) {
        return API({
            url: `${baseUrl}/client/physicalcard/getCouponCourseInfo`,
            method: 'post',
            data,
        })
    },
    getChangeList() {
        return API({
            url: `${baseUrl}/client/physicalcard/userCouponGoodsIds`,
            method: 'post',
        })
       
    }
})